export default __webpack_public_path__ + "static/media/arrow-down.9fe2f5b9.svg";